import React from "react";
import "../styles/ComingSoonPopup.css";

const ComingSoonPopup = ({ onClose }) => {
  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-box" onClick={(e) => e.stopPropagation()}>
        
        <div className="popup-icon">🚀</div>

        <h2>We’re Expanding Soon!</h2>

        <p>
          🚗 <b>AucwiniCars</b> is getting ready to launch in your city.<br /><br />
          We’re working hard to bring you the best car buying & selling experience.<br />
          Stay tuned — something exciting is on the way! ✨
        </p>

        <button onClick={onClose}>Got it 👍</button>
      </div>
    </div>
  );
};

export default ComingSoonPopup;